'use client';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from '@gartner-digital-markets/nimbus-v3-ui';
import { useFormContext } from 'react-hook-form';

interface TextFieldProps {
  name: string;
  label: string;
  placeholder?: string;
  required?: boolean;
  type?: 'text' | 'tel' | 'url';
  onFocus?: () => void;
}

export const TextField = ({
  name,
  label,
  placeholder = '',
  required = false,
  type = 'text',
  onFocus,
}: TextFieldProps) => {
  const { control, getFieldState } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => {
        const fieldState = getFieldState(name);

        return (
          <FormItem>
            <FormLabel className="mb-1 flex items-center gap-1 text-base leading-6 font-bold">
              {label}
              {required && (
                <span aria-hidden={true} className="text-nimbus-destructive">
                  *
                </span>
              )}
            </FormLabel>
            <FormControl>
              <Input
                {...field}
                type={type}
                placeholder={placeholder}
                error={!!fieldState.error}
                onFocus={onFocus}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};
